import molin_10 from '../../assets/images/tra/molin_10.webp';
import '../../styles/common.css'
import { useNavigate } from 'react-router-dom';
import MolinHeader from '../../components/MolinHeader';

export default function SubStreet() {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <MolinHeader></MolinHeader>
      <img src={molin_10} alt="Hero background" className="w-full h-auto" />
      <div className='absolute top-[26%] left-[20%] h-[6vw] w-[12vw] transition-transform duration-300 hover:scale-110'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">项元汴友人(安国)</span>
          <span className="text-[#000000] text-[0.8vw]">A friend of Xiang Yuanbian(An Guo)</span>
        </div>
        <div className="absolute top-[-3vw] left-[4.2vw]">
          <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/friendofxiang")} >
          </button>
        </div>
      </div>
      <div className='absolute top-[30%] left-[50%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">街区2</span>
          <span className="text-[#000000] text-[0.8vw]">Street Block 2</span>
        </div>
        <div className="absolute top-[-3vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/streetblock2")} >
          </button>
        </div>
      </div>
      <div className='absolute bottom-[20%] left-[80%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
        <div className="flex flex-col text-center font-bold">
          <span className="text-[#000000] text-[1vw]">项家 天籁阁</span>
          <span className="text-[#000000] text-[0.8vw]">Xiang's Tianlai Pavilion</span>
        </div>
        <div className="absolute top-[-3vw] left-[4.2vw] cursor-pointer">
          <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
            onClick={() => navigate("/tianlaipavilion")} >
          </button>
        </div>
      </div>
    </div>
  )
}

